  import React, { useState, useEffect, use } from 'react'

  const BlogPost = ({setLoading}) => {

    const [showBlog, setShowBlog] = useState(false);
    const [blogs, setBlogs] = useState([]);
    const [responseMsg, setResponseMsg] = useState('');
    const [showDel, setShowDel] = useState(false);
    const [selectedBlog, setSelectedBlog] = useState('');
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: null,
    posted_on: '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, image: file });
    }
  };

      const handleShowDel = (blog) => {
    setSelectedBlog(blog);
    setShowDel(true);
  }


            useEffect(() => {
                fetchBlogs();
            }, []);


                const fetchBlogs = async () => {
                    setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/get-blog');
        
                        if (response.ok) {
                            const data = await response.json();
  data.sort((a, b) => new Date(b.posted_on) - new Date(a.posted_on));
  setBlogs(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch coupon');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
                };


                const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append('title', formData.title);
    payload.append('description', formData.description);
    payload.append('image', formData.image);
    payload.append('posted_on', formData.posted_on);

    setLoading(true);

    try {
      const response = await fetch('https://api.kcian.in/add-blog', {
        method: 'POST',
        body: payload,
      });

      if (response.ok) {
          setLoading(false);
        setShowBlog(false);
        fetchBlogs();
        setFormData({ tagline: '', description: '', image: null, status: 'Approved' });
          setResponseMsg('Blog Posted Successfully!');
        setTimeout(() => setResponseMsg(''), 3000);
      } else {
          setLoading(false);      
          setResponseMsg('Something went wrong. Try again later.');
        setTimeout(() => setResponseMsg(''), 2000);
      }
    } catch (error) {
      console.error("Error submitting blog:", error);
          setLoading(false);
    }
  };

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};


              const handleDelete = async (blogId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-blog/${blogId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setBlogs((prevProducts) => prevProducts.filter((blog) => blog.id !== blogId));
        setShowDel(false);
        setResponseMsg('Blog deleted successfully!');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);
      } else {
      setResponseMsg('Something Went Wrong. Please try again.');
        setTimeout(() => {
          setResponseMsg('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting blog:', error);
    }
  };


    return (
      <>
              <section className='my-5'>
          <div className='container'>
            <p className='page-heading'>Blog Posts</p>
            <hr />

            <div className='text-end'>
              <button className='notice-btn' onClick={() => setShowBlog(true)}>
                <i className="fa-solid fa-pen-to-square"></i> New Post
              </button>
            </div>



                      {responseMsg && (
              <div className='alert alert-success fw-semibold border-0  mt-2'>{responseMsg}</div>
            )}


  {showBlog && (
    <>
              <div className='notice-card my-3'>
                <p className='fw-bold'>Add Blog</p>


          <form onSubmit={handleSubmit}>

  <div className='mb-3'>
    <label className='login-label'>Posted On*</label>
    <input
      type='date'
      name='posted_on'
      value={formData.posted_on}
      onChange={handleChange}
      className='login-control'
      required
    />
  </div>


            <div className='mb-3'>
              <label className='login-label'>Title*</label>
              <input
                type='text'
                name='title'
                value={formData.title}
                onChange={handleChange}
                className='login-control'
                required
              />
            </div>

            <div className='mb-3'>
              <label className='login-label'>Description*</label>
              <textarea
                name='description'
                value={formData.description}
                onChange={handleChange}
                rows='4'
                className='login-control'
                required
              ></textarea>
            </div>

            <div className='mb-3'>
              <label className='login-label'>Upload Image*</label>
              <input
                type='file'
                accept='image/*'
                onChange={handleImageChange}
                className='login-control'
                required
              />
            </div>


            {formData.image && (
              <div className='mb-3'>
                {/* <label className='login-label'>Image Preview:</label><br /> */}
                <img
                  src={URL.createObjectURL(formData.image)}
                  alt='Preview'
                  className='img-fluid rounded border'
                  style={{ maxHeight: '160px' }}
                />
              </div>
            )}

                    <button type='submit' className='notice-btn2 me-2'>
                      Submit
                    </button>
                    <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowBlog(false)}>
                      Cancel
                    </button>

            {/* <div className='d-flex justify-content-between mt-4'>
              <button type='submit' className='btn btn-success'>Submit</button>
              <button type='button' className='btn btn-secondary' onClick={() => setShowAch(false)}>Cancel</button>
            </div> */}

          </form>

        </div>
    </>
  )}


                {blogs.map(blog => (
                  <div className='notice-card my-3'>
  <div className='row '>
    <div className='col-lg-4 col-md-4 my-2'>
      <img src={`https://api.kcian.in/uploads/${blog.image}`} className='img-fluid' style={{height: '14em'}} />
      </div>

  <div className='col-lg-8 col-md-8 col-12 my-2 align-content-center'>
  <p className='fw-bold fm-mont my-0'>{blog.title}</p>
    <p className='text-muted para-text'>Posted On: {formatDate(blog.posted_on)}</p>
  <p className='text-muted fm-mont'>{blog.description}</p>

  <button className='notice-btn' onClick={() => handleShowDel(blog)} >Delete Blog</button>
    </div>

  </div>
  </div>
                ))}


            </div>
            </section>


                  {showDel && (
    <>
    <section className='dialog-outer'>
        <div className='dialog-inner col-lg-4 mx-auto text-center py-5'>
            
            <p className='fw-semibold'>Want to Delete '{selectedBlog.title}'?</p>

                  <button type='submit' className='notice-btn2 me-2' onClick={() => handleDelete(selectedBlog.id)}>
                    Yes
                  </button>
                  <button type='button' className='notice-btn2 bg-secondary' onClick={() => setShowDel(false)}>
                    No
                  </button>
        </div>
    </section>
    </>
)}
      </>
    )
  }

  export default BlogPost
